module.exports = __webpack_public_path__ + "static/media/Socials.53d355e6.svg";